"use client"

import React from "react"
import { usePathname } from "next/navigation"
import FlyButton from "components/FlyButton"
import PopupButton from "components/PopupButton"

const parseDate = (dateStr) => {
  const [day, month, year] = dateStr.split("-")
  return new Date(Number(year), Number(month) - 1, Number(day))
}

const EventButton = () => {
  const pathname = usePathname()

  const startDate = parseDate("09-07-2025")
  const endDate = parseDate("30-07-2025")
  const today = new Date()

  const isVisible = today >= startDate && today <= endDate && pathname === "/"

  if (!isVisible) return null

  return (
    <>
      <FlyButton />
      <PopupButton />
    </>
  )
}

export default EventButton
